import { SubSink } from 'subsink';
import { MatSidenav } from '@angular/material/sidenav';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, map } from 'rxjs';
import { UserSchema, UserService, AuthService } from 'src/app/core';
import { ResponsiveService, TitleService } from '../services';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  @ViewChild('sidenav') _sidenav!: MatSidenav;

  private subsink = new SubSink();
  private _title: string = 'پنل کاربری | داشبورد';
  public isHandset$: Observable<boolean> = this.responsive.isHandset$;
  @ViewChild('drawer') drawer!: MatSidenav;
  userData!: UserSchema;
  windowsWidth!: number;
  isUserActivated!: boolean;
  
  public isHandset = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((data) => {
      return data.matches;
    })
  );

  constructor(
    private userService: UserService,
    private titleService: TitleService,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private responsive: ResponsiveService,
  ) {}

  ngOnInit() {
    // this.userService.getUser().then((user) => {
    //   this.userData = user;
    //   this.userService.updateUser(user);
    // });

    this.authService.userProfile?.subscribe((userProfile) => {
      this.userData = userProfile;
      this.userService.updateUser(userProfile);
    });

    this.subsink.sink = this.userService.status$.subscribe((statusObj) => {
      if (statusObj.payload && statusObj.status === 'update') {
        this.userData = statusObj.payload;
      }
    });

    this.titleService.setTitle(this._title);
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
